<!--
 * @Description:客户详情底部按钮
 * @Author: cxh
 * @Date: 2022-09-20 15:19:34
 * @LastEditTime: 2022-11-25 10:33:17
 * @LastEditors: cxh
-->
<template>
  <cos-footer-button hideOk>
    <a-button @click="handleAddConcat" v-permission="permissionPage?.concat_add">新增联系人</a-button>
    <a-button
      type="primary"
      v-if="detail && detail.clueStatus !== 1"
      @click="handleEdit"
      v-permission="permissionPage?.edit"
      >编辑</a-button
    >
  </cos-footer-button>
  <!--新增联系人--->
  <ConcatModal ref="concatModalRef" @success="successPage('contact')" :contactRefId="route.query.clueId" />
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConcatModal from '@/components/TabsContacts/zbu/editModal.vue'
const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = defineEmits(['success'])
defineProps({
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  detail: {
    type: Object,
    default: () => {
      return {}
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successPage = (tag: any) => {
  emit('success', tag)
}
//  编辑
const handleEdit = () => {
  router.push({
    path: '/lbu/leadManage/edit',
    query: {
      clueId: route.query.clueId
    }
  })
}
</script>
<script lang="ts">
export default { name: 'viewFooterBtn' }
</script>
